var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { ClassBaseDirective } from '../../../component/base/classbase.directive';
import { ClassService } from '../../../service/class.service';
import { ColumnService } from './column.service';
import { ValidationService } from '../../../service/validation.service';
import { ItemBase } from '../../../models/item/item-base';
var ColumnDirective = /** @class */ (function (_super) {
    __extends(ColumnDirective, _super);
    function ColumnDirective(el, renderer, service, colservice, validService) {
        var _this = _super.call(this, el, renderer, service) || this;
        _this.el = el;
        _this.renderer = renderer;
        _this.service = service;
        _this.colservice = colservice;
        _this.validService = validService;
        _this.orgAddClassList = [];
        _this.addClassList = [];
        _this.removeClassList = [];
        _this.err_el = [];
        _this.err_valid = [];
        return _this;
    }
    ColumnDirective.prototype.ngOnChanges = function (changes) {
        if (changes.col && !changes.col.firstChange) {
            this.setAttribute();
            this.setClass();
        }
    };
    ColumnDirective.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    ColumnDirective.prototype.onInit = function () {
        this.setAttribute();
        this.setClass();
    };
    ColumnDirective.prototype.setAttribute = function () {
        this.el.nativeElement.disabled = this.col.disabled;
        if ((this.tag === 'input' && (this.col.controlType === 'text' || this.col.controlType === 'email')) || this.tag === 'textarea') {
            if (this.col.params && this.col.params.maxlength) {
                this.el.nativeElement.setAttribute('maxlength', this.col.params.maxlength);
            }
            else {
                this.el.nativeElement.removeAttribute('maxlength');
            }
        }
    };
    ColumnDirective.prototype.setClass = function () {
        var _this = this;
        this.orgAddClassList = this.addClassList;
        this.addClassList = [];
        var key = this.tag;
        if ((this.tag === 'input' || this.tag === 'select' || this.tag === 'textarea' || this.tag === 'label' || this.tag === 'img') && this.col.controlType) {
            key = key + '.' + this.col.controlType;
        }
        var def = this.service.getClass(this.key, key);
        if (def) {
            this.setAddClassList(def);
        }
        var form;
        if (this.col.params && this.col.params.formClass) {
            form = this.col.params.formClass;
        }
        if (form) {
            if (this.tag === 'dl') {
                if (typeof form.horizontal !== 'undefined' && form.horizontal === true) {
                    this.setAddClassList('form-leftLabel');
                }
            }
            else if (this.tag === 'li') {
                if (typeof form.width !== 'undefined' && form.width && (!this.col.readonly || this.col.controlType === 'htmlEditor' || this.col.controlType === 'cleditor' || (this.key === 'list' && this.col.readonly && this.col.controlType === 'file'))) {
                    this.setAddClassList('form_li-w' + form.width);
                }
                if (typeof form.height !== 'undefined' && form.height && (!this.col.readonly || this.col.controlType === 'htmlEditor' || this.col.controlType === 'cleditor')) {
                    this.setAddClassList('form_li-h' + form.height);
                }
            }
        }
        if (this.tag === 'li') {
            if (this.col.controlType === 'break') {
                this.setAddClassList('form_li-break');
            }
            if (this.col.controlType === 'checkbox' && this.col.key && this.col.readonly) {
                this.setAddClassList('form_li-inlineList');
            }
            if (this.col.controlType === 'htmlEditor') {
                if (!form || !form.width) {
                    this.setAddClassList('form_li-w100per');
                }
                if (!form || !form.height) {
                    this.setAddClassList('form_li-h200');
                }
            }
            if (this.col.controlType === 'cleditor') {
                if (!form || !form.width) {
                    if (this.key === 'list') {
                        this.setAddClassList('form_li-w400');
                    }
                    else {
                        this.setAddClassList('form_li-w100per');
                    }
                }
            }
            //// kts
            if (this.col.controlType && (this.col.controlType === 'datetime' || this.col.controlType === 'datetimeOperator') && !this.col.readonly) {
                _super.prototype.addClass.call(this, '-m-0');
            }
            if (this.col.controlType && (this.col.controlType === 'time' || this.col.controlType === 'timeOperator') && !this.col.readonly) {
                _super.prototype.addClass.call(this, 'form_li-w100');
            }
        }
        if (this.col.params && this.col.params.addClass) {
            var add = jsonpath.value(this.col.params.addClass, '$.' + key);
            if (add) {
                this.setAddClassList(add);
            }
        }
        if (this.key === 'forminline' && this.tag === 'dt' && !this.col.label) {
            this.removeClassList.push('form_dt-inline');
        }
        if (this.key === 'list' && (!form || !form.width)) {
            if (this.tag === 'input' && this.col.controlType !== 'time') {
                this.setAddClassList('formInputText-widthAuto');
            }
            else if (this.tag === 'textarea') {
                this.setAddClassList('formTextArea-widthAuto');
            }
            else if (this.tag === 'select') {
                this.setAddClassList('formSelect-widthAuto');
            }
        }
        if (this.key === 'list' && this.col.readonly && this.col.controlType === 'textarea') {
            if (this.tag === 'li') {
                if (form && form.width) {
                    this.setAddClassList('form_li-w' + form.width);
                }
                else {
                    this.setAddClassList('form_li-w400');
                }
            }
            else if (this.tag === 'pre') {
                this.setAddClassList('formReadOnly-break');
            }
        }
        this.orgAddClassList.filter(function (x) { return _this.addClassList.indexOf(x) < 0; }).forEach(function (x) { return _super.prototype.removeClass.call(_this, x); });
        this.addClassList.filter(function (x) { return _this.orgAddClassList.indexOf(x) < 0; }).forEach(function (x) { return _super.prototype.addClass.call(_this, x); });
        this.removeClassList.forEach(function (x) { return _super.prototype.removeClass.call(_this, x); });
    };
    ColumnDirective.prototype.setAddClassList = function (add) {
        if (typeof add === 'string') {
            // "class1" or "class1 class2 ..."
            var adds = add.split(' ');
            Array.prototype.push.apply(this.addClassList, adds);
        }
        else if (add instanceof Array) {
            // ["class1", "class2", ...]
            Array.prototype.push.apply(this.addClassList, add);
        }
    };
    ColumnDirective.prototype.addErrors = function (errors) {
        if (!this.col || (!this.col.key && this.col.controlType !== 'displayTarget')) {
            return;
        }
        var cls = this.service.getClass(this.key, 'error.' + this.col.controlType);
        var el = this.el.nativeElement.parentElement.querySelector('.formError:not(.formValidationError)');
        var el_v = this.el.nativeElement.parentElement.querySelector('.formValidationError');
        if (el) {
            for (var _i = 0, _a = this.err_el; _i < _a.length; _i++) {
                var err = _a[_i];
                this.renderer.removeChild(err.p, err.text);
                this.renderer.removeChild(this.el.nativeElement.parentNode, err.p);
            }
            this.err_el = [];
        }
        if (errors.length > 0) {
            if (cls) {
                _super.prototype.addClass.call(this, cls);
            }
            this.err_el = [];
            for (var _b = 0, errors_1 = errors; _b < errors_1.length; _b++) {
                var error = errors_1[_b];
                var err_p = this.renderer.createElement('p');
                var err_text = this.renderer.createText(error);
                this.renderer.addClass(err_p, 'formError');
                this.renderer.appendChild(err_p, err_text);
                this.renderer.insertBefore(this.el.nativeElement.parentNode, err_p, this.el.nativeElement);
                this.err_el.push({ p: err_p, text: err_text });
            }
        }
        else {
            if (cls && !el_v) {
                _super.prototype.removeClass.call(this, cls);
            }
        }
        this.validService.afterValidation();
    };
    ColumnDirective.prototype.addValidationError = function (error) {
        if (!this.col || !this.col.key) {
            return;
        }
        var msgs = [];
        var errFlg = false;
        if (typeof error.validationError !== 'undefined' && typeof error.validationError[this.col.key] !== 'undefined') {
            msgs = error.validationError[this.col.key];
            errFlg = true;
        }
        var cls = this.service.getClass(this.key, 'error.' + this.col.controlType);
        var el = this.el.nativeElement.parentElement.querySelector('.formError');
        if (el) {
            for (var _i = 0, _a = this.err_valid; _i < _a.length; _i++) {
                var err_v = _a[_i];
                this.renderer.removeChild(err_v.p, err_v.text);
                this.renderer.removeChild(this.el.nativeElement.parentNode, err_v.p);
            }
            this.err_valid = [];
        }
        if (errFlg) {
            if (cls) {
                _super.prototype.addClass.call(this, cls);
            }
            this.err_valid = [];
            for (var _b = 0, msgs_1 = msgs; _b < msgs_1.length; _b++) {
                var msg = msgs_1[_b];
                var err_p = this.renderer.createElement('p');
                var err_text = this.renderer.createText(msg);
                this.renderer.addClass(err_p, 'formError');
                this.renderer.addClass(err_p, 'formValidationError');
                this.renderer.appendChild(err_p, err_text);
                this.renderer.insertBefore(this.el.nativeElement.parentNode, err_p, this.el.nativeElement);
                this.err_valid.push({ p: err_p, text: err_text });
            }
        }
        else {
            if (cls && this.err_el.length === 0) {
                _super.prototype.removeClass.call(this, cls);
            }
        }
        this.validService.afterValidation();
    };
    ColumnDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[columnDir]'
                },] }
    ];
    /** @nocollapse */
    ColumnDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ClassService },
        { type: ColumnService },
        { type: ValidationService }
    ]; };
    ColumnDirective.propDecorators = {
        col: [{ type: Input }],
        val: [{ type: Input }]
    };
    return ColumnDirective;
}(ClassBaseDirective));
export { ColumnDirective };
//# sourceMappingURL=column.directive.js.map